module.exports = __webpack_public_path__ + "static/media/female.ace99a73.svg";